/** @file Link button that navigates to the register start page. */
import * as tsx from 'vue-tsx-support';
import * as icons from '@codegrade/icons';
import { Icon } from '@/components/Icon';
import { clsButtonLikeLink } from './cls';
import { routeRegisterStart } from './routes';
/** Button link to the register page. */
export const GotoRegisterLink = tsx.component({
    name: 'goto-register-link',
    /** @returns The rendered tenant list link JSX. */
    render() {
        return (<router-link data-cy="goto-register" class={clsButtonLikeLink} to={routeRegisterStart(this.$router)}>
                Register a new CodeGrade account
                <Icon icon={icons.ArrowRight}/>
            </router-link>);
    },
});
